export enum PaymentFlowType {
  RegularOffer = 'RegularOffer',
  SplitBooking = 'SplitBooking',
  ExistingBooking = 'ExistingBooking',
  ResumeBooking = 'ResumeBooking'
}

export enum PiccErrorType {
  OfferCheckFailed = 'picc_offer_check_failed',
  Ineligible = 'picc_ineligible',
  ClearedBeforeResult = 'picc_cleared_before_result'
}
